import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { menus } from './menus';
import { WikiPlugin } from '@fondationcss/wiki'
import LogoColor from '@/svg/alcuin.svg';
import LogoWhite from '@/svg/alcuin-white.svg';

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@fondationcss/wiki/dist/style.css';
import '@fondationcss/markdown/dist/style.css';
import '@fondationcss/markdown/dist/markdown.css';
import "@/styles.css";
import 'highlight.js/styles/github.css';


const config = {
  AppName: 'Alcuin',
  SiteNameShort: 'Alcuin',
  SiteNameLong: 'Byrnu Alcuin',
  LogoLine1: 'Byrnu',
  LogoLine2: 'Alcuin',
  Copyright: 'Copyright © 2026',
  
  MenuGroupsOrientation: 'vertical',
  Menus: menus,
  EnableAccessRequestButton: false,

  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',
  LogoHomepage: LogoColor,
  LogoGantt: LogoColor,
  LogoHeader: LogoWhite,
  LogoFooter: LogoColor,
  HideLoginLogo: true,
  
} as IConfiguration;

const vuetify = createVuetify({
    components,
    directives,
    ...vuetifyOptions
  })
const app = createApp(App);
const router = getRouter(getCustomRoutes);
app.provide('config', config)
app.provide('sdkOptions', { apiUrl: import.meta.env.VITE_API_URL ?? undefined })
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
library.add(far)
app.use(createPinia());
app.use(PerfectScrollbarPlugin);
app.use(router);
// Type assertion needed due to Vue 3.5+ stricter Plugin generic constraints
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(WikiPlugin as any, { router })
app.mount('#app');
